/**
 * Reads free-doubt count from DC quota payloads:
 * - GET `/dc/1/availableFreeDoubts`
 * - GET `/dc/1/availableFreeDoubtsFromSource` (e.g. source `AINA`)
 *
 * Handles both top-level and nested `data.availableFreeDoubts` (standard envelopes).
 */
export function getAvailableFreeDoubtsCount(payload: unknown): number {
  if (payload == null || typeof payload !== "object") {
    return 0;
  }
  const raw = payload as Record<string, unknown>;
  const nested = raw.data;
  const fromNested =
    nested != null && typeof nested === "object" && !Array.isArray(nested)
      ? (nested as Record<string, unknown>).availableFreeDoubts
      : undefined;
  const direct = raw.availableFreeDoubts;
  const candidate = fromNested ?? direct;
  if (typeof candidate === "number" && Number.isFinite(candidate)) {
    return Math.max(0, Math.floor(candidate));
  }
  const n = Number(candidate);
  return Number.isFinite(n) && n >= 0 ? Math.floor(n) : 0;
}
